import React from "react";
import { Copy } from "lucide-react";
import { activationUrl, fmtDateTime } from "./ui";

export default function LinkResult({ result, testId }) {
  if (!result) return null;
  const url = activationUrl(result.resetToken);
  return (
    <div
      className="mt-3 text-[12px] bg-[#8AA986]/15 border border-[#8AA986]/40 rounded-lg px-3 py-2 break-all"
      data-testid={testId}
    >
      <div className="flex items-center justify-between gap-2">
        <strong>Enlace de un solo uso · vence {fmtDateTime(result.expiresAt)}</strong>
        <button
          type="button"
          onClick={() => navigator.clipboard?.writeText(url)}
          className="inline-flex items-center gap-1 text-[11px] font-semibold hover:underline shrink-0"
          data-testid={`${testId}-copy`}
        >
          <Copy className="h-3 w-3" /> Copiar
        </button>
      </div>
      <code className="block mt-1">{url}</code>
      <p className="mt-1 text-[11px] text-[#132C44]/60">Compartilo por WhatsApp o email. Al generar uno nuevo, el anterior deja de funcionar.</p>
    </div>
  );
}
